import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/auth/` || "http://localhost:8080/api/auth/";

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "signin", {
        username,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
          response.data.time = Date.now()
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(nome, username, email, password, unidade) {
    return axios.post(API_URL + "signup", {
      nome,
      username,
      email,
      password,
      unidade
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }
}

export default new AuthService();
